/**
  申し込み用フォーム[動画制作]コンポーネント
*/
<template>
<div id="formVideoProduction" class="form_group">
  <div class="rap1_boder" id="">
    <Section><h1 class="wrap_title pd_7">動画制作</h1></Section>
    <Column class="pd3_parts width15">
      <ul class="c-choices">
        <li class="c-choices__item">
          <label class="c-choice">
            <input type="radio" class="required" name="video_production" value="スタンダード">
            <span class="">スタンダード</span>
          </label>
        </li>
        <li class="c-choices__item">
          <label class="c-choice">
            <input type="radio" class="required" name="video_production" value="ビジネス">
            <span class="">ビジネス</span>
          </label>
        </li>
        <li class="c-choices__item">
          <label class="c-choice">
            <input type="radio" class="required" name="video_production" value="プレミアム">
            <span class="">プレミアム</span>
          </label>
        </li>
      </ul>
    </Column>
    <!-- <Column>
      <label>サービス内容内訳項目1</label>
      <input type="text" class="required form_txt" id="service_content_item1_video_production">
    </Column>
    <Column>
      <label>サービス内容金額1</label>
      <input type="text" inputmode="numeric" class="required form_txt" placeholder="半角数字で入力" id="service_content_item1_price_video_production">
    </Column> -->
  </div>
</div>
</template>


<script>
import { defineComponent } from 'vue'

// コンポーネントを読み込む
import Variables from '../../../molecules/variables.vue';
import Choices from '../../../molecules/choices.vue';
import Box from '../../../molecules/box.vue';
import Section from '../../../molecules/section.vue';
import Column from '../../../molecules/column.vue';
import Group from '../../../molecules/group.vue';
import Flex from '../../../molecules/flex.vue';
import Block from '../../../molecules/block.vue';

import Description from '../../../atoms/description.vue';
import Label from '../../../atoms/label.vue';
import Input from '../../../atoms/input.vue';
import Select from '../../../atoms/select.vue';
import Textarea from '../../../atoms/textarea.vue';
import Button from '../../../atoms/button.vue';
import IconAdd from '../../../atoms/icon-add.vue';
import IconRemove from '../../../atoms/icon-remove.vue';

export default defineComponent({
  name: 'formApplicationVideoProduction',

  components: {
    Variables,
    Choices,
    Box,
    Section,
    Column,
    Group,
    Flex,
    Block,

    Description,
    Label,
    Input,
    Select,
    Textarea,
    Button,
    IconAdd,
    IconRemove,
  },

  methods: {
  },

  mounted() {
  },

  setup(_, context) {
    return {}
  }

})
</script>
